import React from 'react';
import { Link } from 'react-router-dom';
import './PillarCard.css';

const PillarCard = ({ pillar, highlightedSubmenus = [] }) => {
  return (
    <div className="pillar-card">
      {/* Icon is now a direct child of the card for easier corner positioning */}
      {pillar.live && <i className="fas fa-circle live-indicator-pillar"></i>}

      <div className="pillar-card-header">
        <i className={`pillar-icon ${pillar.icon}`}></i>
        <h3 className="pillar-title">{pillar.title}</h3>
      </div>
      
      <div className="pillar-card-content">
        <ul className="sub-menu-list">
          {pillar.children.map(submenu => {
            const isHighlighted = highlightedSubmenus.includes(submenu.title);
            
            // Logic to combine multiple potential classes
            const liClassName = [
              isHighlighted ? 'highlighted' : '',
              submenu.live ? 'live-submenu' : ''
            ].filter(Boolean).join(' '); // filter(Boolean) removes any empty strings

            return (
              <li key={submenu.title} className={liClassName}>
                {/* Submenu icon remains next to the text */}
                {submenu.live && <i className="fas fa-circle live-indicator-submenu"></i>}
                <Link to={submenu.path}>{submenu.title}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PillarCard;